import { Component, Inject, input, output } from '@angular/core';
import { ServerAPI } from '../../serverapi';
import { JSBridgeService } from '../jsbridge.service';
import { HistoryEntry } from '@server/src/types';
import { SelectionEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'kop-history-list',
  templateUrl: './kop-history-list.component.html',
  styleUrl: './kop-history-list.component.scss'
})
export class KopHistoryListComponent {

  constructor(@Inject('ServerApi') public electronApi: ServerAPI, private jsBridgeService: JSBridgeService) {
    this.getHistory();
  }

  public kopHistory: HistoryEntry[] = [];

  public onHistorySelected = output<HistoryEntry>()
  public selectedHistory = input<HistoryEntry>();  

  public refresh() {
    this.getHistory();
  }

  private async getHistory() {
    let klantNo = this.jsBridgeService.getKlantNo();
    if (klantNo != undefined) {
      let ret = await this.electronApi.getKopHistory(klantNo);
      ret.unshift({id: undefined, date: new Date()});
      
      this.kopHistory = ret;
      let sh = this.selectedHistory();
      if (sh != undefined && sh.id != undefined) {
        let h = this.kopHistory.find(h => h.id == sh.id);
        if (h != undefined) {
          this.onHistorySelected.emit(h);
        }
      }
    }
  }

  public gridSelectionChanged(event: SelectionEvent) {
    console.log(event);
    if (event.selectedRows != undefined && event.selectedRows.length > 0) {
      this.onHistorySelected.emit(event.selectedRows[0].dataItem);
    }
  }

}
